import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'hour4u-admin-success-signed-page',
  templateUrl: './success-signed-page.component.html',
  styleUrls: ['./success-signed-page.component.scss']
})
export class SuccessSignedPageComponent implements OnInit {
  seconds: number = 5;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.startRedirectCountdown();
  }

  startRedirectCountdown() {
    const intervalId = setInterval(() => {
      this.seconds -= 1;
      if (this.seconds <= 0) {
        clearInterval(intervalId);
        this.router.navigate(['/job'], { relativeTo: this.route });
      }
    }, 1000);
  }

}
